import { useState } from "react";
import { CATEGORIES } from "../utils/constants";
import styles from "../styles/theme";

export default function AuthScreen({ screen, setScreen, onLogin, onRegister }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (!email || !password)
      return setError("Please fill in all required fields.");
    if (screen === "register" && !name)
      return setError("Please enter your name.");
    if (screen === "register" && !inviteCode)
      return setError("Please enter an invite code.");
    if (password.length < 6)
      return setError("Password must be at least 6 characters.");
    setLoading(true);
    const err =
      screen === "login"
        ? await onLogin(email, password)
        : await onRegister(email, password, name, inviteCode);
    setLoading(false);
    if (err) setError(err);
  };

  return (
    <div style={styles.authContainer}>
      <div style={styles.authDecoration}>
        <div style={styles.authDecoInner}>
          <span style={{ ...styles.logoIcon, fontSize: 48 }}>◉</span>
          <h1 style={styles.authDecoTitle}>PeopleGraph</h1>
          <p style={styles.authDecoSub}>
            Your personal relationship journal. Remember every connection,
            visualize your network, never forget a face.
          </p>
          <div style={styles.authDecoNodes}>
            {["Work", "Family", "Social", "Community"].map((label, i) => (
              <div
                key={label}
                style={{
                  ...styles.authDecoNode,
                  animationDelay: `${i * 0.3}s`,
                  background: CATEGORIES[i].color,
                }}
              >
                {CATEGORIES[i].icon} {label}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={styles.authFormSide}>
        <div style={styles.authFormContainer}>
          <h2 style={styles.authTitle}>
            {screen === "login" ? "Welcome back" : "Create your account"}
          </h2>
          <p style={styles.authSubtitle}>
            {screen === "login"
              ? "Sign in to access your people journal"
              : "Start mapping your personal network"}
          </p>

          {error && <div style={styles.authError}>{error}</div>}

          {screen === "register" && (
            <div style={styles.fieldGroup}>
              <label style={styles.fieldLabel}>Full Name</label>
              <input
                style={styles.input}
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Jane Doe"
              />
            </div>
          )}
          <div style={styles.fieldGroup}>
            <label style={styles.fieldLabel}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </div>
          <div style={styles.fieldGroup}>
            <label style={styles.fieldLabel}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            />
          </div>
          {screen === "register" && (
            <div style={styles.fieldGroup}>
              <label style={styles.fieldLabel}>Invite Code</label>
              <input
                style={styles.input}
                type="text"
                value={inviteCode}
                onChange={(e) => setInviteCode(e.target.value)}
                placeholder="Enter your invite code"
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              />
            </div>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={styles.authSubmitBtn}
          >
            {loading
              ? "..."
              : screen === "login"
                ? "Sign In"
                : "Create Account"}
          </button>

          <p style={styles.authSwitch}>
            {screen === "login"
              ? "Don't have an account? "
              : "Already have an account? "}
            <span
              style={styles.authSwitchLink}
              onClick={() => {
                setScreen(screen === "login" ? "register" : "login");
                setError("");
              }}
            >
              {screen === "login" ? "Sign up" : "Sign in"}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
